
function Banner() {
  return <div className="site-banner" aria-hidden="true" />;
}

export default Banner;
